import React from "react";

const Th: React.FC = props => {
  return (
      <th style={{ backgroundColor: 'skyblue', color: 'black' }}>
        {props.children}
      </th>
  );
};
export default Th;